module.exports = __webpack_public_path__ + "static/app-store-badge-zh-c4ca0eac4e5d39c399c3b8daeb794506.png";